import { render, staticRenderFns } from "./EmailBinding.vue?vue&type=template&id=2b5c5598&"
import script from "./EmailBinding.vue?vue&type=script&lang=js&"
export * from "./EmailBinding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports